// extracted by mini-css-extract-plugin
module.exports = {"groupState":"TelegramGroupState_groupState__1m8Jh","tooltipIcon":"TelegramGroupState_tooltipIcon__2Ckhy"};